import { InputNumber as AntInputNumber, type InputNumberProps as AntInputNumberProps } from 'antd';
import type { ValueType } from 'rc-input-number';
import type { FC } from 'react';

export type InputNumberProps<T extends ValueType = ValueType> = AntInputNumberProps<T>;

export const InputNumber = <T extends ValueType = ValueType>({
  parser = value => value?.replace(/,/g, '.').replace(/[^\d.+-]/g, '') as unknown as T,
  ...props
}: InputNumberProps<T>): ReturnType<FC<InputNumberProps<T>>> => {
  return <AntInputNumber parser={parser} {...props} />;
};
